// Small-variant image helpers.
//
// The server bakes a ~640px WebP alongside every upload and returns it on a
// parallel field. Anywhere an image renders small — list cards, grid thumbs,
// map callouts — should read the variant; only full-bleed detail surfaces and
// lightboxes should pull the original.
//
// Every helper falls back to the original, so a row uploaded before the
// variants existed still renders.

// Event banner as shown on a card or map callout.
export const eventBannerThumb = (event) =>
  event?.bannerThumbnailUrl || event?.bannerImageUrl || null;

// A route/landmark gallery photo as shown in the grid (the lightbox keeps imageUrl).
export const photoThumb = (photo) =>
  photo?.thumbnailUrl || photo?.imageUrl || null;

// A vehicle's cover image as shown in the garage grid.
export const vehicleCoverThumb = (uv) =>
  uv?.primaryThumbnailUrl || uv?.primaryImageUrl || uv?.images?.[0]?.imageUrl || null;
